import { createApp, onMounted } from 'vue';

import { useDynamicYieldCampaigns } from '~/composables/use-dynamic-yield-campaigns';
import { GLOBAL_CAMPAIGNS, RECOMMENDATIONS_CAMPAIGNS } from '~/constants/campaigns';
import { SHOPIFY_TEMPLATE_TYPES } from '~/constants/shopify';

import { BaseSection } from './base-section';

/**
 * Component that initializes Dynamic Yield campaigns using centralized constants
 * instead of relying on Shopify settings.
 */
class DyCampaignsInitializer extends BaseSection {
  constructor() {
    super('[data-section-type="dy-campaigns-initializer"]');
  }

  init(instanceData) {
    const container = instanceData.container;
    const pageType = container.dataset.pageType || '';

    createApp({
      name: 'DyCampaignsInitializerSection',
      render() {
        return null;
      },
      setup() {
        const { initializeCampaigns } = useDynamicYieldCampaigns();

        // Configure Campaigns to be loaded
        const campaignsToInitialize = [
          GLOBAL_CAMPAIGNS.MULTI_TOUCH_TEST,
          GLOBAL_CAMPAIGNS.CART_LAYOUT,
        ];

        // Configure Recommendations to be loaded by specific shopify template types
        if (pageType === SHOPIFY_TEMPLATE_TYPES.INDEX) {
          campaignsToInitialize.push(RECOMMENDATIONS_CAMPAIGNS[SHOPIFY_TEMPLATE_TYPES.INDEX]);
        } else if (pageType === SHOPIFY_TEMPLATE_TYPES.PRODUCT) {
          campaignsToInitialize.push(RECOMMENDATIONS_CAMPAIGNS[SHOPIFY_TEMPLATE_TYPES.PRODUCT]);
        } else if (pageType === SHOPIFY_TEMPLATE_TYPES.COLLECTION) {
          campaignsToInitialize.push(RECOMMENDATIONS_CAMPAIGNS[SHOPIFY_TEMPLATE_TYPES.COLLECTION]);
        } else if (pageType === SHOPIFY_TEMPLATE_TYPES.ARTICLE) {
          campaignsToInitialize.push(RECOMMENDATIONS_CAMPAIGNS[SHOPIFY_TEMPLATE_TYPES.ARTICLE]);
        } else if (pageType === SHOPIFY_TEMPLATE_TYPES.PAGE) {
          campaignsToInitialize.push(RECOMMENDATIONS_CAMPAIGNS[SHOPIFY_TEMPLATE_TYPES.PAGE]);
        } else if (pageType === SHOPIFY_TEMPLATE_TYPES.NOT_FOUND_ERROR) {
          campaignsToInitialize.push(
            RECOMMENDATIONS_CAMPAIGNS[SHOPIFY_TEMPLATE_TYPES.NOT_FOUND_ERROR],
          );
        } else if (pageType === SHOPIFY_TEMPLATE_TYPES.SEARCH) {
          // If needed, we can add a search campaign here
        }

        const filteredCampaigns = campaignsToInitialize.filter((campaign) => campaign);

        onMounted(() => {
          initializeCampaigns(filteredCampaigns);
        });

        return {};
      },
    }).mount(container);
  }

  onUnload(instanceData) {
    const app = instanceData.container.__vue_app__;
    if (app) {
      app.unmount();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new DyCampaignsInitializer();
});
